// extracted by mini-css-extract-plugin
export default {"empty":"Chart_empty__r7izq"};